module.exports = __webpack_public_path__ + "img/dots-4.04e366d5.svg";